/**
 * Lab Product Card Video Hover
 * 
 * Handles video autoplay on hover for product cards.
 * Videos are lazy loaded and only play when the user hovers over the card.
 */

(function() {
  'use strict';

  function initVideoHover() {
    const productCards = document.querySelectorAll('.lab-product-card-gallery--has-video');
    
    productCards.forEach(card => {
      const videoContainer = card.querySelector('.lab-product-card-video');
      if (!videoContainer) return;
      
      const deferredMedia = videoContainer.querySelector('deferred-media');
      if (!deferredMedia) return;
      
      let videoElement = null;
      let isVideoLoaded = false;
      let isPlaying = false;
      
      // Function to load and play video
      function loadAndPlayVideo() {
        if (isVideoLoaded && videoElement) {
          if (videoElement.tagName === 'VIDEO') {
            videoElement.play().catch(err => {
              console.warn('Lab Product Card Video: Could not autoplay video', err);
            });
          } else if (videoElement.tagName === 'IFRAME') {
            // For iframes (YouTube/Vimeo), they should autoplay via URL parameters
            // But we can try to trigger play if there's an API
            if (videoElement.contentWindow && typeof videoElement.contentWindow.postMessage === 'function') {
              // Try to play via postMessage for YouTube/Vimeo
              if (videoElement.src.includes('youtube.com')) {
                videoElement.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
              } else if (videoElement.src.includes('vimeo.com')) {
                videoElement.contentWindow.postMessage('{"method":"play"}', '*');
              }
            }
          }
          isPlaying = true;
        } else if (!isVideoLoaded) {
          // Hide play button immediately
          const playButton = deferredMedia.querySelector('.deferred-media__poster-button');
          if (playButton) {
            playButton.style.display = 'none';
            playButton.style.visibility = 'hidden';
            playButton.style.opacity = '0';
            playButton.style.pointerEvents = 'none';
          }
          
          // Load the video by triggering deferred-media
          if (deferredMedia.showDeferredMedia) {
            deferredMedia.showDeferredMedia();
            
            // Wait a bit for the video to load, then find it
            setTimeout(() => {
              videoElement = deferredMedia.querySelector('video, iframe');
              if (videoElement) {
                isVideoLoaded = true;
                
                // Set video attributes for autoplay and loop
                if (videoElement.tagName === 'VIDEO') {
                  videoElement.setAttribute('autoplay', '');
                  videoElement.setAttribute('loop', '');
                  videoElement.setAttribute('muted', '');
                  videoElement.setAttribute('playsinline', '');
                  videoElement.setAttribute('controls', 'false');
                  
                  // Play the video
                  videoElement.play().catch(err => {
                    console.warn('Lab Product Card Video: Could not autoplay video', err);
                  });
                }
                
                isPlaying = true;
              }
            }, 100);
          } else {
            // Fallback: manually load the template content
            const template = deferredMedia.querySelector('template');
            if (template) {
              const content = template.content.cloneNode(true);
              deferredMedia.appendChild(content);
              
              // Find the video element
              videoElement = deferredMedia.querySelector('video, iframe');
              if (videoElement) {
                isVideoLoaded = true;
                
                // Set video attributes for autoplay and loop
                if (videoElement.tagName === 'VIDEO') {
                  videoElement.setAttribute('autoplay', '');
                  videoElement.setAttribute('loop', '');
                  videoElement.setAttribute('muted', '');
                  videoElement.setAttribute('playsinline', '');
                  videoElement.setAttribute('controls', 'false');
                  
                  // Play the video
                  videoElement.play().catch(err => {
                    console.warn('Lab Product Card Video: Could not autoplay video', err);
                  });
                }
                
                isPlaying = true;
              }
            }
          }
        }
      }
      
      // Function to pause video and hide it
      function pauseVideo() {
        if (videoElement && videoElement.tagName === 'VIDEO') {
          videoElement.pause();
          videoElement.currentTime = 0; // Reset to beginning
        } else if (videoElement && videoElement.tagName === 'IFRAME') {
          // Pause iframe videos
          if (videoElement.src.includes('youtube.com')) {
            videoElement.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (videoElement.src.includes('vimeo.com')) {
            videoElement.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
        isPlaying = false;
        
        // Ensure video container is hidden
        if (videoContainer) {
          videoContainer.style.opacity = '0';
          videoContainer.style.visibility = 'hidden';
        }
        
        // Ensure image is visible
        const imageContainer = card.querySelector('.lab-product-card-image');
        if (imageContainer) {
          imageContainer.style.opacity = '1';
        }
      }
      
      // Handle mouse enter (hover)
      card.addEventListener('mouseenter', () => {
        loadAndPlayVideo();
        
        // Ensure video container is visible
        if (videoContainer) {
          videoContainer.style.opacity = '1';
          videoContainer.style.visibility = 'visible';
        }
        
        // Hide image
        const imageContainer = card.querySelector('.lab-product-card-image');
        if (imageContainer) {
          imageContainer.style.opacity = '0';
        }
      });
      
      // Handle mouse leave
      card.addEventListener('mouseleave', () => {
        pauseVideo();
      });
      
      // Handle touch events for mobile (optional - you might want to disable this)
      let touchTimeout = null;
      card.addEventListener('touchstart', () => {
        clearTimeout(touchTimeout);
        touchTimeout = setTimeout(() => {
          loadAndPlayVideo();
        }, 300);
      });
      
      card.addEventListener('touchend', () => {
        clearTimeout(touchTimeout);
        pauseVideo();
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoHover);
  } else {
    initVideoHover();
  }
  
  // Re-initialize on section re-render (for Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initVideoHover);
  }
  
  // Also initialize when new content is loaded (for dynamic content)
  const observer = new MutationObserver(() => {
    initVideoHover();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

